import { apiClient } from './client';
import {AxiosResponse} from 'axios';
import {Page} from "@/models/Page";
import {array} from "yup";

const baseUrl = "/page"


export const getChildren = (slug: string) => {
    return apiClient.get(`/piece?slug=${slug}`)
}

export const getPageContents = (slug: string, locale:string = "en") => {
    return apiClient.get(`/piece/${slug}`)
};

export const getCuratedOffers = () => {
    return apiClient.get(`/curated-offers`);
};

export const getCharterBundles = () => {
    return apiClient.get(`/charter-bundles`);
};

export const getHomePageContents = () => {
    return apiClient.get(`/page`)
};
